/******************************************************************************
 *** SysAcntgYearMng ** 회계연도 관리 * 조합비 관리자가 추가 / 시스템 관리자가 수정 or 삭제
*******************************************************************************/
import AppContext from "@/js/common/AppContext";
import Button from "@/js/common/ui/Button";
import Util from "@/js/common/Util";
import React from "react";
import Axios from "@/js/common/Axios";
import Modal from "@/js/common/ui/modal/Modal";
import DialogTitleBar from "@/js/system/common/DialogTitleBar";
import SysAcntgYearSaveDialog from "./dialog/SysAcntgYearSaveDialog";
import { useRecoilValue } from "recoil";
import * as Atom from "@/js/common/Atom";

const SysAcntgYearMng = () => {
    const userInfo = useRecoilValue(Atom.userInfo);
    const [callTime, setCallTime] = React.useState<Date>(new Date());
    const [dataArr , setDataArr ] = React.useState<any[]>([]);

    // 모달
    const [modalOpen, setModalOpen] = React.useState<boolean>(false);
    const [acntgYear, setAcntgYear] = React.useState<string>("");

    // 조회
    React.useEffect(() => {
        AppContext.showSpinner();

        Axios.dataAccess({
            url: "system/sys/acntg/year/select-acntg-year-list.do",
            methodType: "post",
            paramType: "json",
            paramData: {},
            onSuccessFn: (res: any) => {
                setDataArr(res.result.list || []);
                AppContext.hideSpinner();
            },
        });
    }, [callTime]);

    // 회계연도 추가
    const doInsert = () => {
        AppContext.openAlert({
            title: "회계연도 추가",
            msg: "다음 회계연도를 추가하시겠습니까?",
            icon: "warning",
            confirmText: "추가",
            handleConfirm: () => {
                AppContext.showSpinner();
                Axios.dataAccess({
                    url: "system/sys/acntg/year/save-acntg-year.do",
                    methodType: "post",
                    paramType: "json",
                    paramData: {},
                    onSuccessFn: () => {
                        AppContext.hideSpinner();
                        AppContext.openAlert({
                            title: "회계연도 추가 완료",
                            msg: "다음 회계연도 추가되었습니다.",
                            icon: "success",
                        });
                        setCallTime(new Date());
                    },
                });
            },
        });
    };


    // 삭제(메인에서 처리)
    const handleDelete = (row: any) => {
        if (Util.isEmpty(row.acntgYear)) return;

        AppContext.openAlert({
            title: "삭제",
            msg: `"${row.acntgYear}년" 회계연도를 삭제하시겠습니까?`,
            icon: "warning",
            confirmText: "삭제",
            handleConfirm: () => {
                AppContext.showSpinner();

                Axios.dataAccess({
                    url: "system/sys/acntg/year/delete-acntg-year.do",
                    methodType: "post",
                    paramType: "json",
                    paramData: {
                        acntgYear: row.acntgYear,
                    },
                    onSuccessFn: () => {
                        AppContext.hideSpinner();
                        AppContext.openAlert({
                            title: "회계연도 삭제 완료",
                            msg: row.acntgYear + "년 회계연도가 삭제되었습니다.",
                            icon: "success",
                            });
                        setCallTime(new Date());
                    },
                });
            },
        });
    };

  const ynText = (yn: any) => (String(yn || "") === "Y" ? "Y" : "N");

    return (
        <div className="w1200 bgcWhite p20 bdrd8 mt10 boxShadowSoft">
            {/* 타이틀 */}
            <div className="mt5">
                <span className="dpBlock w100p fm-c fs25 fc2c3e50 ls1 pb10">회계연도 관리</span>
                <div className="bdt3 bdc007bff pb10"></div>
            </div>

            {/* 목록 타이틀 */}
            <div className="dpFlx aiC jcSb mb10 h44">
                <div className="fm-b fs16 fc007bff ls1 fw700">
                    <span>회계연도 목록</span>
                </div>
                <Button buttonName="회계연도 추가"
                    width={130} height={40}
                    fontFamily="fm-b" fontSize={16} letterSpacing={-1}
                    variant="styCompleteBtn"
                    borderRadius={6}
                    buttonClass="dpFlx aiC jcC"
                    onClickFunc={() => doInsert()}
                />
            </div>

            {/* 테이블 */}
            <div className="w100p bsBdb bgcFDFCFC bdt1 bdcC5C5C5">
                <table className="w100p tlF tbl-collapse">
                    <colgroup>
                        <col style={{ width: "14%" }} />
                        <col style={{ width: "20%" }} />
                        <col style={{ width: "20%" }} />
                        <col style={{ width: "12%" }} />
                        <col style={{ width: "12%" }} />
                        <col style={{ width: "22%" }} />
                    </colgroup>

                    <thead>
                        <tr>
                        {["회계연도", "회계 시작일", "회계 종료일", "입력 가능", "마감 여부", "관리"].map((label) => (
                            <th key={label} className="p0 bd1 bdcEDEDED">
                            <div className="h40 dpFlx aiC jcC pw12 bgcF1F8FF fm-Pretendard-Medium fs14 fw400 fc34495e ls1 wsNw ofH toE">
                                {label}
                            </div>
                            </th>
                        ))}
                        </tr>
                    </thead>

                    <tbody>
                        {dataArr.length === 0 ? (
                            <tr>
                                <td colSpan={6} className="p0 bd1 bdcEDEDED">
                                    <div className="ph25 taC fc999999 fm-Pretendard-Regular fs13 ls075">조회된 데이터가 없습니다.</div>
                                </td>
                            </tr>
                        ) : (
                            dataArr.map((row: any, idx: number) => (
                                <tr key={idx} className="bgcF9F9F9-hover transitionBgc">
                                    <td className="p0 bd1 bdcEDEDED">
                                        <div className="h35 dpFlx aiC jcC pw12 fm-c fs14 fc666666 ls075">
                                            {row.acntgYear}
                                        </div>
                                    </td>
                                    <td className="p0 bd1 bdcEDEDED">
                                        <div className="h35 dpFlx aiC jcC pw12 fm-c fs14 fc666666 ls075">
                                            {Util.cvtDateStrForm(String(row.acntgBgngYmd), "-", "YYYYMMDD")}
                                        </div>
                                    </td>
                                    <td className="p0 bd1 bdcEDEDED">
                                        <div className="h35 dpFlx aiC jcC pw12 fm-c fs14 fc666666 ls075">
                                            {Util.cvtDateStrForm(String(row.acntgEndYmd), "-", "YYYYMMDD")}
                                        </div>
                                    </td>
                                    <td className="p0 bd1 bdcEDEDED">
                                        <div className="h35 dpFlx aiC jcC pw12 fm-c fs14 fc666666 ls075">
                                            {ynText(row.inptPsbltyYn)}
                                        </div>
                                    </td>
                                    <td className="p0 bd1 bdcEDEDED">
                                        <div className="h35 dpFlx aiC jcC pw12 fm-c fs14 fc666666 ls075">
                                            {ynText(row.ddlnYn)}
                                        </div>
                                    </td>

                                    {/* 시스템관리자 관리: 수정/삭제 */}
                                    {userInfo.systemAdmin === "Y" ? (
                                        <td className="p0 bd1 bdcEDEDED">
                                            <div className="h35 dpFlx aiC jcC gap30 pw12">
                                                <Button buttonName="수정"
                                                    width={70} height={28}
                                                    fontFamily="fm-b" fontSize={13} letterSpacing={-1}
                                                    variant="styTempBtn"
                                                    borderRadius={4} buttonClass="dpFlx aiC jcC"
                                                    onClickFunc={() => {
                                                        setAcntgYear(row.acntgYear);
                                                        setModalOpen(true);
                                                    }}
                                                />
                                                <Button buttonName="삭제"
                                                    width={70} height={28}
                                                    fontFamily="fm-b" fontSize={13} letterSpacing={-1}
                                                    variant="styDeleteBtn"
                                                    borderRadius={4} buttonClass="dpFlx aiC jcC"
                                                    onClickFunc={() => handleDelete(row)}
                                                />
                                            </div>
                                        </td>
                                    )
                                    :
                                    <td className="p0 bd1 bdcEDEDED">
                                        <div className="h35 dpFlx aiC jcC pw12 fm-c fs13 fc828282 ls075">
                                            회계연도 수정/마감은 시스템관리자에게 문의
                                        </div>
                                    </td>
                                }
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* 모달 */}
            <Modal modalOpen={modalOpen} dim={true} visible={true} titleEl={<DialogTitleBar title={"회계연도 수정"} />}
                onCloseFunc={() => {
                    setAcntgYear("");
                    setModalOpen(false);
                }}
            >
                <div className="h329">
                    <SysAcntgYearSaveDialog
                        acntgYear    = {acntgYear}
                        setModalOpen = {setModalOpen}
                        setCallTime  = {setCallTime}
                    />
                </div>
            </Modal>
        </div>
    );
};

export default SysAcntgYearMng;
